import { heroComics, stats } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[640px] w-full items-center overflow-hidden bg-background-100 md:min-h-[760px]"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20whimsical%20comic%20storybook%20scene%20with%20floating%20objects%2C%20spirals%2C%20stars%20and%20tiny%20characters%20drifting%20upward%2C%20warm%20coral%20orange%20and%20teal%20green%20on%20cream%20background%2C%20flat%20modern%20vector%20illustration%2C%20playful%20and%20dreamy%2C%20high%20detail&width=1600&height=900&seq=qm-hero-bg&orientation=landscape"
          alt="奇妙漫画网奇思妙想创意短篇插画背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 md:px-6 md:py-28">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-bold text-secondary-900">
              <i className="ri-sparkling-2-line" />
              奇思妙想 · 创意短篇在线速看
            </span>
            <h1 className="font-heading mt-5 text-4xl leading-tight text-foreground-950 md:text-5xl">
              通勤摸鱼，都能看完
              <span className="block text-primary-600">一篇奇妙短篇</span>
            </h1>
            <p className="mt-4 text-base leading-relaxed text-foreground-700 md:text-lg">
              这里聚集了最精彩的脑洞短篇与创意短篇漫画，题材丰富、节奏紧凑、短小精悍却回味无穷。不用长篇连载，随时随地，翻开就是好故事。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#featured"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .querySelector("#featured")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-center text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                立即开始阅读
              </a>
              <a
                href="#categories"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .querySelector("#categories")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="whitespace-nowrap rounded-full border border-background-300 bg-background-50/70 px-7 py-3 text-center text-sm font-bold text-foreground-900 backdrop-blur transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                浏览题材分类
              </a>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="grid grid-cols-4 gap-4">
              {heroComics.map((c, i) => (
                <div
                  key={c.title}
                  className={`rounded-xl bg-background-50 p-1.5 ${
                    i === 1 || i === 3 ? "translate-y-8" : ""
                  }`}
                >
                  <img
                    src={c.cover}
                    alt={`${c.title}短篇漫画封面`}
                    className="aspect-[3/4] w-full rounded-lg object-cover object-top"
                  />
                  <p className="px-1 pt-2 text-center text-xs font-bold text-foreground-800">
                    {c.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 gap-4 rounded-2xl border border-background-200 bg-background-50/70 p-6 backdrop-blur md:grid-cols-4 md:mt-24">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl text-primary-600 md:text-3xl">
                {s.value}
              </p>
              <p className="mt-1 text-sm text-foreground-700">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}